module.exports = __webpack_public_path__ + "img/61.9.TU.812f5585.png";